export default "__VITE_ASSET__DnVxKaHE__"